<template>
  <a-modal :title="!dataForm.id ? '新增' : '编辑'" :visible="visible" :maskClosable="false" :confirmLoading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" width="800px">
    <a-form-model ref="ruleForm" :model="dataForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="所属片区" prop="belongingAreaId">
            <a-tree-select v-model="dataForm.belongingAreaId" style="width: 100%" :tree-data="zoneTreeData"
              :replace-fields="{ title: 'zoneName', key: 'id', value: 'id' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择所属片区" allow-clear
              @select="handleZoneSelect" treeDefaultExpandAll />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="水表编号" prop="waterMeterNumber">
            <a-input v-model="dataForm.waterMeterNumber" placeholder="请输入水表编号" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="用户编码" prop="userCode">
            <a-input v-model="dataForm.userCode" placeholder="请输入用户编码" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="安装日期" prop="installDate">
            <a-date-picker v-model="dataForm.installDate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
              style="width: 100%" placeholder="请选择安装日期" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="平行大用户名称" prop="userName">
            <a-input v-model="dataForm.userName" placeholder="请输入平行大用户名称" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="水表口径" prop="caliber">
            <a-input v-model="dataForm.caliber" placeholder="请输入水表口径" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="用户地址" prop="userAddress">
            <a-input v-model="dataForm.userAddress" placeholder="请输入用户地址" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="水表厂家" prop="manufacturer">
            <a-input v-model="dataForm.manufacturer" placeholder="请输入水表厂家" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="纬度" prop="latitude">
            <a-input v-model="dataForm.latitude" placeholder="请输入纬度" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="经度" prop="longitude">
            <a-input v-model="dataForm.longitude" placeholder="请输入经度" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="高程" prop="elevation">
            <a-input v-model="dataForm.elevation" placeholder="请输入高程" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'UserAddOrUpdate',
  data () {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      queryOneUrl: '/zone-metering/parallel/user/id/select',//根据id查询
      getZoneListUrl: '/zone-metering/zone-metering',//片区选项
      addOrUpdateUrl: '/zone-metering/parallel/user/one/insert/update',
      dataForm: {
        id: 0,
        zoneId: undefined,
        belongingAreaId: undefined,
        belongingArea: '',
        waterMeterNumber: '',
        userCode: '',
        installDate: null,
        userName: '',
        caliber: '',
        userAddress: '',
        manufacturer: '',
        latitude: '',
        longitude: '',
        elevation: ''
      },
      zoneTreeData: [],
      rules: {
        belongingAreaId: [{ required: true, message: '请选择所属片区', trigger: 'change' }],
        waterMeterNumber: [{ required: true, message: '请输入水表编号', trigger: 'blur' }],
        userCode: [{ required: true, message: '请输入用户编码', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入平行大用户名称', trigger: 'blur' }],
        userAddress: [{ required: true, message: '请输入用户地址', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.getZoneData()
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
        if (this.dataForm.id) {
          this.$http.get(`${this.queryOneUrl}/${this.dataForm.id}`).then(({ data }) => {
            this.dataForm = data
            // 回显时设置 belongingArea
            if (this.dataForm.belongingAreaId && this.zoneTreeData.length > 0) {
              this.findZoneName(this.zoneTreeData, this.dataForm.belongingAreaId)
            }
          })
        } else {
          // 新增时重置 belongingArea
          this.dataForm.belongingArea = ''
        }
      })
    },
    getZoneData () {
      this.$http.get(this.getZoneListUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    handleZoneSelect (value, node, extra) {
      this.dataForm.belongingArea = node.dataRef.zoneName
    },
    // 递归查找 zoneName
    findZoneName (data, id) {
      for (let item of data) {
        if (item.id === id) {
          this.dataForm.belongingArea = item.zoneName
          return
        }
        if (item.children && item.children.length > 0) {
          this.findZoneName(item.children, id)
        }
      }
    },
    handleOk () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          const params = {
            ...this.dataForm
          }

          if (!this.dataForm.id) {
            delete params.id
          }

          // 确保 belongingArea 存在，如果为空尝试从树中查找
          if (!params.belongingArea && params.belongingAreaId && this.zoneTreeData.length > 0) {
            this.findZoneName(this.zoneTreeData, params.belongingAreaId)
            params.belongingArea = this.dataForm.belongingArea
          }

          const request = this.dataForm.id ?
            this.$http.put(this.addOrUpdateUrl, params)
            : this.$http.post(this.addOrUpdateUrl, params)
          request.then(res => {
            console.log(res);

            this.$message.success('操作成功')
            this.visible = false
            this.$emit('refreshDataList')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>
